import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { and, not, PrivateRoute, Roles } from '@/js/libs/use-auth';

import Dashboard from 'src/scenes/Dashboard';
import Status from 'src/scenes/Status';

const index = true;

export const dashboardRouteObject = inferRouteObject({
  path: 'dashboard',
  element: <PrivateRoute roles={and(Roles.AGENCY, not(Roles.POSTADMANAGER))} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: Dashboard.Helmet,
      children: [
        // TODO Cleanup after redesign #15324
        { index, element: <Navigate to='/orders' replace /> },
        {
          Component: Dashboard.Providers,
          children: [
            { index, Component: Dashboard.Dashboard },
            { path: 'documents', Component: Dashboard.Documents },
          ],
        },
      ],
    },
  ],
});
